"use client";

import dynamic from "next/dynamic";

const WritersDropdown = dynamic(
  () =>
    import("./WritersDropdown").then((mod) => ({
      default: mod.WritersDropdown,
    })),
  { ssr: false }
);

export function LazyWritersDropdown() {
  return <WritersDropdown />;
}
